<template>
   <div class="">
   
    <router-link  class="mr-2 invoice_btn" :to="{path: `/Retail-Outlet/service/transactions/${data.id}`, query: {serviceName: data.name, branchId: $route.query.branchId, companyId: $route.query.companyId}}">
         {{$t('text.clickButtons.transactionHistory')}}
    </router-link>
    <router-link  class="mr-3 btn btn-info"   :to="{ name: 'CreateBranchTransaction', query: {companyId: $route.query.companyId, branchId: $route.query.branchId, serviceId: data.id, serviceName: data.name}}">
         {{$t('text.clickButtons.addTransaction')}}
    </router-link>
  </div>
</template>

<script>
import Jquery from "jquery";
let $ = Jquery;
import {serviceMixins}  from "@/mixins/servicesMxins"

export default {
    mixins: [serviceMixins],
    data() {
        return {
            data: {
                services: []
            },
        };
    },
    mounted() {
    },
    methods: {
        addTransaction() {
             this.$store.commit("setBanchTransactions" , 
               [...this.$store.getters.getBanchTransactions, {service: this.data.id, serviceName: this.data.name, price: 0, description: this.data.description}]
            )
            this.$store.commit("setBranchServiceIds" , 
                [...this.$store.getters.getBranchServiceIds, data.id]
            )  

        }
    },
};

</script>